import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'react-i18next';
import CustomButton from '../Button/Button';

const styles = theme => ({
    buttonSection: {
        display: 'flex',
        padding: '14px',
    },
    buttonLeft: {
        marginLeft: 'auto'
    },
    buttonRight: {
        marginLeft: '15px'
    },
});


const ActionButtons = (props) => {
    const { classes, submit, disabledSubmit, cancel, submitText, cancelText, cancelColor = 'secondary', colorSubmit = 'primary', size = 'medium', t } = props;

    const finalSubmitText = submitText || t('common:Action.ok');
    const finalCancelText = cancelText || t('common:Action.cancel');

    return (
        <div className={classes.buttonSection}>
            <CustomButton disabled={disabledSubmit} onClick={submit} className={classes.buttonLeft} variant="contained" color={colorSubmit} size={size}>
                {finalSubmitText}
            </CustomButton>
            <CustomButton onClick={cancel} className={classes.buttonRight} variant="contained" color={cancelColor} size={size}>
                {finalCancelText}
            </CustomButton>
        </div>
    )
}
export default translate('common')(withStyles(styles)(ActionButtons));